import axios from '@/modules/axios';

function loadServices() {
	return axios.get('/services');
}

function createService(payload) {
	return axios.post('/services', payload);
}

function loadServiceById(serviceId) {
	return axios.get(`/services/${serviceId}`);
}

function updateService(serviceId, payload) {
	return axios.put(`/services/${serviceId}`, payload);
}

function deleteService(serviceId) {
	return axios.delete(`/services/${serviceId}`);
}

export {
	loadServices,
	createService,
	loadServiceById,
	updateService,
	deleteService,
};



// WEBPACK FOOTER //
// ./src/modules/api/Service.js